export default __webpack_public_path__ + "static/bobson wong-2625c139e338d395b139d27ffb38a4d1.png";